import { lazy, Suspense } from 'react';
import { injectReducer } from '../store';
import { Outlet } from 'react-router';

const Companies = lazy(() => import('./Table'));
const Company = lazy(() => import('./Company'));
const AddCompany = lazy(()=> import("./AddCompany/Index"))

const Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="calendar 10">
      <g id="Vector">
        <path
          d="M17.4545 3.81818H16.5455V2.90909C16.5455 2.66799 16.4497 2.43675 16.2792 2.26627C16.1087 2.09578 15.8775 2 15.6364 2C15.3953 2 15.164 2.09578 14.9935 2.26627C14.8231 2.43675 14.7273 2.66799 14.7273 2.90909V3.81818H12.9091V2.90909C12.9091 2.66799 12.8133 2.43675 12.6428 2.26627C12.4723 2.09578 12.2411 2 12 2C11.7589 2 11.5277 2.09578 11.3572 2.26627C11.1867 2.43675 11.0909 2.66799 11.0909 2.90909V3.81818H9.27273V2.90909C9.27273 2.66799 9.17695 2.43675 9.00646 2.26627C8.83597 2.09578 8.60474 2 8.36364 2C8.12253 2 7.8913 2.09578 7.72081 2.26627C7.55032 2.43675 7.45455 2.66799 7.45455 2.90909V3.81818H6.54545C5.34037 3.81963 4.18505 4.29898 3.33293 5.15111C2.4808 6.00323 2.00144 7.15855 2 8.36364V17.4545C2.00144 18.6596 2.4808 19.8149 3.33293 20.6671C4.18505 21.5192 5.34037 21.9986 6.54545 22H17.4545C18.6596 21.9986 19.8149 21.5192 20.6671 20.6671C21.5192 19.8149 21.9986 18.6596 22 17.4545V8.36364C21.9986 7.15855 21.5192 6.00323 20.6671 5.15111C19.8149 4.29898 18.6596 3.81963 17.4545 3.81818ZM6.54545 5.63636H7.45455V6.54545C7.45455 6.78656 7.55032 7.01779 7.72081 7.18828C7.8913 7.35877 8.12253 7.45455 8.36364 7.45455C8.60474 7.45455 8.83597 7.35877 9.00646 7.18828C9.17695 7.01779 9.27273 6.78656 9.27273 6.54545V5.63636H11.0909V6.54545C11.0909 6.78656 11.1867 7.01779 11.3572 7.18828C11.5277 7.35877 11.7589 7.45455 12 7.45455C12.2411 7.45455 12.4723 7.35877 12.6428 7.18828C12.8133 7.01779 12.9091 6.78656 12.9091 6.54545V5.63636H14.7273V6.54545C14.7273 6.78656 14.8231 7.01779 14.9935 7.18828C15.164 7.35877 15.3953 7.45455 15.6364 7.45455C15.8775 7.45455 16.1087 7.35877 16.2792 7.18828C16.4497 7.01779 16.5455 6.78656 16.5455 6.54545V5.63636H17.4545C18.1776 5.63709 18.8709 5.92465 19.3822 6.43596C19.8935 6.94727 20.1811 7.64054 20.1818 8.36364H3.81818C3.8189 7.64054 4.10647 6.94727 4.61778 6.43596C5.12909 5.92465 5.82236 5.63709 6.54545 5.63636ZM17.4545 20.1818H6.54545C5.82236 20.1811 5.12909 19.8935 4.61778 19.3822C4.10647 18.8709 3.8189 18.1776 3.81818 17.4545V10.1818H20.1818V17.4545C20.1811 18.1776 19.8935 18.8709 19.3822 19.3822C18.8709 19.8935 18.1776 20.1811 17.4545 20.1818Z"
          fill="currentColor"
        />
        <path
          d="M15.0525 12.178C14.8182 11.9407 14.4303 11.9407 14.196 12.178L10.6808 15.737L9.39596 14.4361C9.16162 14.1989 8.77374 14.1989 8.53939 14.4361C8.30505 14.6734 8.30505 15.0661 8.53939 15.3034L10.1071 16.8907C10.4222 17.2098 10.9313 17.2098 11.2465 16.8907L15.0444 13.0452C15.2869 12.808 15.2869 12.4152 15.0525 12.178Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

const Wrapper = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Outlet />
  </Suspense>
);

const CompaniesConfig = {
  name: 'Companies',
  path: 'companies',
  element: <Wrapper />,
  Icon,
  children: [
    {
      path: '',
      element: <Companies />
    },
    {
      path: ':companyId',
      element: <Company onCompanySubmit={() => {}} />
    },
    {
      path: 'new',
      element: <AddCompany />
    }
  ],
  loader: () => {
    return import('./redux/slice').then((slice) => {
      injectReducer('companies', slice.default);
      return true;
    });
  }
};

export default CompaniesConfig;